import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { alpha, styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { Box, Stack, AppBar, Toolbar, IconButton, Typography, Avatar } from '@mui/material';

import { bgBlur } from '../../../utils/cssStyles';
import Iconify from '../../../components/iconify';
import Theme from '../../theme/Theme';
import NavConfig from '../nav/config';
import useResponsive from '../../../hooks/useResponsive';
import { HorizontalNavSection } from '../../../components/nav-section';
import Nav from '../nav';

let HEADER_MOBILE = 35;
let HEADER_DESKTOP = 50;
const ONLY_ICON = true;

const StyledRoot = styled(AppBar)(({ theme, scrolled }) => ({
  ...(!scrolled && bgBlur({ color: theme.palette.background.default })),
  ...(scrolled && bgBlur({ color: theme.palette.background.default })),
  boxShadow: scrolled ? '0px 2px 4px rgba(0, 0, 0, 0.2)' : '0px 0px 0px rgba(0, 1px 2px, 0.05)',
  [theme.breakpoints.up('sm')]: {
    width: `calc(100%)`,
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up('sm')]: {
    minHeight: HEADER_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

export default function Header({ currentPosition, onOpenNav, open, setOpen }) {
  const scrolled = currentPosition === 0;

  if (scrolled) {
    HEADER_MOBILE = 50;
    HEADER_DESKTOP = 70;
  } else {
    HEADER_MOBILE = 35;
    HEADER_DESKTOP = 50;
  }

  const allowedNavConfigs = NavConfig();
  const isDesktop = useResponsive('up', 'lg');
  const navigate = useNavigate();

  const onCloseNav = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const handleToLanding = () => {
    navigate('/landing');
  };

  return (
    <>
      <StyledRoot scrolled={scrolled}
        sx={{
          bgcolor: (theme) => (theme.palette.mode === 'light' ? '#cee8e9' : ''),
          backgroundImage: (theme) =>
            `linear-gradient(135deg, ${alpha(theme.palette.primary.lighter, 0)} 0%, ${alpha(
              theme.palette.primary.light,
              0.24
            )} 100%)`,
        }}>
        <StyledToolbar>
          <Typography
            onClick={handleToLanding}
            variant="h5"
            sx={{ cursor: 'pointer', color: 'darkgray', display: 'flex', gap: 1 }}
          >
            <Avatar src="/assets/logo/eotc-logo.png" alt="photoURL" sx={{ height: scrolled ? 35 : 30, width: scrolled ? 35 : 30, }} />
            <Typography variant={scrolled ? "h4" : "h6"} sx={{ display: { xs: 'none', sm: 'block' }, color: 'darkgray' }}>
              የሰሜን ሸዋ ሀገረ ስብከት የመረጃ አስተዳደር ስርዓት!
            </Typography>
            <Typography variant={scrolled ? "h5" : "h6"} sx={{ display: { xs: 'block', sm: 'none' }, color: 'darkgray' }}>
              አቡቀለምሲስ
            </Typography>
          </Typography>
          <Box sx={{ flexGrow: 1 }} />

          <Stack
            direction="row"
            alignItems="center"
            spacing={{
              xs: 0.5,
              sm: 1,
            }}
          >
            {!isDesktop && <Nav openNav={open} onCloseNav={onCloseNav} />}
            {isDesktop && (
              <>
                <HorizontalNavSection allowedNavConfigs={allowedNavConfigs} />
                <Theme ONLY_ICON={ONLY_ICON} />
              </>
            )}
            <IconButton
              onClick={onOpenNav}
              sx={{
                mr: 1,
                color: 'text.primary',
                display: { lg: 'none' },
              }}
            >
              <Iconify icon="eva:menu-2-fill" />
            </IconButton>
          </Stack>
        </StyledToolbar>
      </StyledRoot>
    </>
  );
}
Header.propTypes = {
  onOpenNav: PropTypes.func,
  currentPosition: PropTypes.string,
  open: PropTypes.bool,
  setOpen: PropTypes.func,
};
